<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-module" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Update
                </div>

                <div class="modal-body pb-0">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col">
                                <v-textarea label="Namn" v-model="name" variant="outlined"></v-textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Close
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Save
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ModuleService from "../../Services/ModuleService";
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['moduleupdated'],
        name: 'update-module',
        props: {

        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async save() {
                if (this.moduleId == -1) {
                    await ModuleService.addModule(this.name);
                }
                else {
                    await ModuleService.updateModule(this.moduleId, this.name)
                }
                this.$emit("moduleupdated");   
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            open(item) {
                this.name = item.Name;
                this.moduleId = item.ModuleId;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            create() {
                this.reset();
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            reset() {
                this.moduleId = -1;
                this.name = "";
            },
        },
        data() {
            return {
                dialogueVisible: false,
                name: "",
                moduleId: -1,
                thisModal: {},
            };
        },
        watch: {

        },
        mounted() {
            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});
        },
        //setup(props, { emit }) {
        //    emit('moduleupdated')
        //}
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content{
        border-radius:unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }
    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius:unset;
    }
</style>
